import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation
import './Register.css';
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";
import CONFIG from '../config';

function UserInput() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState('');
  const [showIcon, setShowIcon] = useState(true);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [scanFrom, setScanFrom] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  
  const location = useLocation();
  
  useEffect(() => {

    const queryParams = new URLSearchParams(location.search);
    const website = queryParams.get('website');
    
    console.log('Website parameter:', website);
    
    const rememberedUsername = localStorage.getItem('username');
    const rememberedPassword = localStorage.getItem('password');
    const storedScanFrom = localStorage.getItem('scan_from') || '';
    setScanFrom(storedScanFrom);
    if (rememberedUsername && rememberedPassword) {
      setUsername(rememberedUsername);
      setPassword(rememberedPassword);
      setRememberMe(true);
    }
  }, [location.search]);

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const handleUserNameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const navigateToLogin = () => {
    navigate('/');
  }


  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

const requestOtp = async () => {
  try {
    const response = await axios.post(
      `${CONFIG.API_BASE_URL}/user-line-oa/request-otp`,
      new URLSearchParams({ cust_tel: phone }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    console.log('OTP Response:', response.data);
    alert(`ส่งรหัส OTP ไปยังเบอร์ ${phone} แล้ว`);
    return response.data.otp_code; // Only for dev/testing – remove in prod
  } catch (error) {
    console.error('OTP request failed:', error);
    alert('ไม่สามารถส่งรหัส OTP ได้ กรุณาลองใหม่');
    throw error;
  }
};


  const handleSubmit = async () => {

    if (isSubmitting) return; // prevent double submission
    setIsSubmitting(true);

    try {
      //  const otp = await requestOtp();

      //   // 👉 Show a simple browser prompt to ask user for the OTP code
      //   const userEnteredOtp = prompt("กรุณากรอกรหัส OTP ที่คุณได้รับ:");

      //   if (userEnteredOtp !== otp) {
      //     alert("รหัส OTP ไม่ถูกต้อง");
      //     setIsSubmitting(false);
      //     return;
      //   }
      // 1) Create the new user
      const postData = new FormData();
      postData.append("invbill", "Uficon");
      postData.append("birthdate", birthDate.toString());
      postData.append("invcust_name", `${firstName} ${lastName}`);
      postData.append("cust_tel", phone);
      postData.append("line_user_id", localStorage.getItem('line_user_id'));
      postData.append("email", localStorage.getItem('username'));
      postData.append("scan_from", scanFrom);

      const createRes = await axios.post(
        `${CONFIG.API_BASE_URL}/user-line-oa/create`,
        postData
      );
      // The response payload is assumed to be { message: "...", id: <newId> }
      const newUserId = createRes.data.id;
      console.log("Created user with ID:", newUserId);

      // 2) Fetch all “point events” from /coupon/
      //    (adjust the query‐string exactly as your backend expects)
      const couponRes = await axios.get(
        `${CONFIG.API_BASE_URL}/point-events/`,
        {
          params: {
            page: 1,
            limit: 1000
          }
        }
      );
      const events = couponRes.data.content.data; 
      // events is an array of objects like { event_id, target_register, reward_value_fixed, start_at, end_at, ... }

      // 3) For each event that has target_register=true AND now ∈ [start_at, end_at], call add-point
      const now = new Date();
      for (const ev of events) {
        // Check if this event qualifies
        if (ev.target_register) {
          const start = new Date(ev.start_at);
          const end = new Date(ev.end_at);
          if (now >= start && now <= end) {
            const increment = ev.reward_value_fixed || 0;
            if (increment > 0) {
              try {
                // We send as x-www-form-urlencoded: increment=<number>
                await axios.post(
                  `${CONFIG.API_BASE_URL}/user-line-oa/add-point/${newUserId}`,
                  new URLSearchParams({ increment: increment.toString() }),
                  {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  }
                );
                console.log(`Added ${increment} points for event ${ev.event_id}`);
              } catch (err) {
                console.error(`Failed to add ${increment} points for event ${ev.event_id}:`, err);
              }
            }
          }
        }
      }

      await manualAddCoupon();

      // 4) Done—navigate away or show a success message
      navigate('/');
      setIsSubmitting(false);

    } catch (err) {
      console.error("Error in handleSubmit:", err);
      alert("ขออภัย! คุณมีข้อมูลในระบบแล้ว หรือ มีข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง");
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
      navigate('/');
    }
  };

    const forceRedeemCoupon = async (couponId) => {
    try {
      const response = await axios.post(
        `${CONFIG.API_BASE_URL}/coupon/force_redeem_coupon`,
        null,
        {
          params: {
            line_user_id: localStorage.getItem('line_user_id'),
            coupon_id: couponId
          },
          headers: {
            accept: 'application/json'
          }
        }
      );
      console.log("Force redeem coupon succeeded:", response.data);
    } catch (error) {
      console.error("Force redeem coupon failed:", error);
    }
  };

   async function manualAddCoupon() {
    await forceRedeemCoupon(56);
    await forceRedeemCoupon(58);
    await forceRedeemCoupon(61);
    await forceRedeemCoupon(62);

  }


  return (
    <div>
       {isSubmitting ? 
          <div style={{ marginTop: '10px', textAlign: 'center', color: '#00a9a5' }}>
            กำลังดำเนินการ โปรดรอสักครู่...
          </div>
        :  <header>
    <div  style={{
                    width: '100%',
                    backgroundColor: '#f2f3f5',
                  }}>
      <div
                  style={{
                    padding: '50px'
                  }}
                >
                  <img src="/assets/logo U-01.png" alt="Logo" className="logo" />
        <div className="welcome-text">Welcome to iStudio by UFicon</div>
        <div className="login-header">กรอกข้อมูลผู้ใช้</div>
        
        <div className="input-group-userinput">
  <div className="input-label">ชื่อจริง</div>
  <input
    type="text"
    className="input-field"
    placeholder="ชื่อจริง"
    value={firstName}
    onChange={(e) => setFirstName(e.target.value)}
  />
</div>

<div className="input-group-userinput">
  <div className="input-label">นามสกุล</div>
  <input
    type="text"
    className="input-field"
    placeholder="นามสกุล"
    value={lastName}
    onChange={(e) => setLastName(e.target.value)}
  />
</div>

<div className="input-group-userinput">
  <div className="input-label">เบอร์โทรศัพท์</div>
  <input
    type="tel"
    className="input-field"
    placeholder="0812345678"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
  />
</div>

<div className="input-group-userinput">
  <div className="input-label">วันเกิด</div>
  <input
    type="date"
    className="input-field"
    value={birthDate}
    onChange={(e) => setBirthDate(e.target.value)}
  />
</div>







        <div className="input-group-userinput">
            <button onClick={() => handleSubmit()} className="login-button">ลงทะเบียน</button>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', fontFamily:'Prompt', fontSize:'13px',marginTop:'10px' }}>
              <div style={{color:'grey', padding:'10px'}}>ต้องการเปลี่ยนบัญชีผู้ใช้,</div>
              <div  style={{color:'#00a9a5', fontWeight:'bold'}} onClick={navigateToLogin}>เข้าสู่ระบบ</div>
        </div>

        </div>
        
        </div>
        <br/><br/><br/><br/><br/><br/><br/><br/>
      </header>}
     
    </div>
  );
}

export default UserInput;
